// 地图 Web 端 Key 配置
// 这里写入的是「高德地图 Web 端」的 Key，用于后台管理系统的地图功能。
// 如需更换，只要修改下面这一行即可。

// 高德地图 Web 端 Key（来自你控制台截图）
export const AMAP_WEB_KEY = 'c8195f16e102400976dff7307807f1cd';


